/** Lazy same-origin loader for the Sentinel GeoLibre React GIS runtime. */

export const GEOLIBRE_RUNTIME_REL_PATH = "assets/geolibre-runtime.js";

let runtimePromise = null;

export function resolveGeoLibreRuntimeUrl() {
  if (typeof document === "undefined") return GEOLIBRE_RUNTIME_REL_PATH;
  return new URL(GEOLIBRE_RUNTIME_REL_PATH, document.baseURI).href;
}

export function ensureGeoLibreRuntimeLoaded() {
  if (typeof window !== "undefined" && window.CrocGeoLibre) {
    return Promise.resolve(window.CrocGeoLibre);
  }
  if (runtimePromise) return runtimePromise;
  runtimePromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = resolveGeoLibreRuntimeUrl();
    script.async = true;
    script.dataset.crocGeolibre = "1";
    script.onload = () => {
      if (window.CrocGeoLibre) resolve(window.CrocGeoLibre);
      else reject(new Error("GeoLibre runtime did not register"));
    };
    script.onerror = () => reject(new Error("GeoLibre runtime load failed"));
    document.head.appendChild(script);
  }).catch((error) => {
    runtimePromise = null;
    throw error;
  });
  return runtimePromise;
}

